import React from 'react'
import PropTypes from 'prop-types'
import { ContextHeadline } from '@aok/text-elements'
import { PictureWithStructuredData } from '@aok/image'

import MacroContainer from '../../_layout/Macro/MacroContainer'

const M008 = ({ quote, author, profession, image }) => {
  return (
    <MacroContainer dataTrackingName="M008">
      <div itemScope itemType="https://schema.org/Quotation" className="m008 bg-faf8eb">
        <div
          className="
            flex flex-col gap-40
            px-16 py-48
            600:p-64
            840:p-80
            1000:px-104
          "
        >
          <ContextHeadline
            className="
                font-buenos-aires font-semibold
                text-005e3f text-28 leading-36
                1000:text-32 1000:leading-44
              "
            itemProp="text"
          >
            {`„${quote}“`}
          </ContextHeadline>
          <div
            className="
              flex flex-row flex-nowrap items-center gap-16
              600:gap-24
            "
          >
            {image && (
              <PictureWithStructuredData {...image} className="flex-shrink-0" imgClassName="rounded-full w-80 h-80" />
            )}
            <div>
              <p itemScope itemType="https://schema.org/Person" itemProp="spokenByCharacter">
                <span itemProp="name" className="text-16 leading-24">
                  {author}
                </span>
                <br />
                <span itemProp="jobTitle" className="text-14 leading-20 text-586167">
                  {profession}
                </span>
              </p>
              {image?.copyright && <p className="text-12 leading-18 text-586167">© {image.copyright}</p>}
            </div>
          </div>
        </div>
      </div>
    </MacroContainer>
  )
}

M008.propTypes = {
  quote: PropTypes.string,
  author: PropTypes.string,
  profession: PropTypes.string,
  image: PropTypes.shape({
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        breakpoint: PropTypes.number,
      })
    ),
    alt: PropTypes.string,
    contentUrl: PropTypes.string,
    license: PropTypes.string,
  }),
}

M008.defaultProps = {
  quote:
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
  author: 'Max Mustermann',
  profession: 'Lorem-Impsum Experte',
}

export default M008
